/**
 * @file src/pages/device-settings/useGetDevices.js
 * @description React Query hook for fetching registered EGS devices.
 */

import { useQuery } from "@tanstack/react-query";
import { getDevices } from "api/device.api";
import { QUERY_KEYS } from "config/queryKeys";

export const useGetDevices = (params = {}) => {
  return useQuery({
    queryKey: QUERY_KEYS.devices.list(params),
    queryFn: () => getDevices(params),
    select: (data) => data?.data ?? [],
    staleTime: 1000 * 60 * 30,
  });
};
